import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const ridgeWoodHeightsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Ridge Wood Heights Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Ridge Wood Heights, FL. Sam\'s Tree Service handles hazardous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_ridge_wood_heights',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Ridge Wood Heights',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Ridge Wood Heights Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     residential streets and properties of <strong>Ridge Wood Heights</strong>. Mature 
     trees are part of what makes this neighborhood great but when they grow unchecked, 
     they create real risks. Heavy limbs over roofs, overgrown canopies blocking gutters, 
     and storm damaged trunks all need expert attention before they become expensive 
     problems.`,

    `We specialize in <strong>hazardous tree situations</strong> from large limb removal 
     and canopy reduction to full tree takedowns on tight residential lots. Our crew works 
     cleanly and carefully, protecting your yard, structures, and neighboring properties 
     throughout the entire job.`,

    `<strong>Sam's Tree Service</strong> offers reliable, expert tree care throughout 
     <strong>Ridge Wood Heights</strong> and the surrounding <strong>Sarasota</strong> 
     area keeping your trees healthy and your property safe through every Florida storm season.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Ridge Wood Heights, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_RidgeWoodHeights = () => <LocationPage config={ridgeWoodHeightsConfig} />;
export default Services_RidgeWoodHeights;
